@if (isEmpty()) {
  <p class="nv-notif-panel__empty">Nothing needs attention right now.</p>
} @else {
  @if (totalRequests() > 0) {
    <div class="nv-notif-panel__group">
      <div class="nv-notif-panel__group-head">
        <span class="nv-notif-panel__label">Guest requests</span>
        <button type="button" nvButton="text" size="xs" (click)="viewAllRequests()">
          View all ({{ totalRequests() }})
        </button>
      </div>
      @for (request of requests(); track request.id) {
        <div class="nv-notif-panel__row">
          <div class="nv-notif-panel__row-text">
            <span class="nv-notif-panel__row-title">{{ tableLabel(request.tableId) }} · {{ reasonLabel[request.reason] }}</span>
            @if (request.note) {
              <span class="nv-notif-panel__row-sub">“{{ request.note }}”</span>
            }
            <span class="nv-notif-panel__row-age">{{ ageLabel(request.createdAt) }}</span>
          </div>
          @if (request.reason === 'pin_reset' && canSetPin()) {
            <button type="button" nvButton="primary" size="xs" (click)="openSetPin(request)">Set PIN</button>
          }
          @if (request.reason === 'water' && canAddWater()) {
            <button
              type="button"
              nvButton="primary"
              size="xs"
              [disabled]="isAcknowledging(request.id)"
              (click)="addWater(request)"
            >
              {{ isAcknowledging(request.id) ? 'Adding…' : 'Add water' }}
            </button>
          } @else {
            <button
              type="button"
              nvButton="primary"
              size="xs"
              [disabled]="isAcknowledging(request.id)"
              (click)="acknowledge(request.id)"
            >
              {{ isAcknowledging(request.id) ? 'Acknowledging…' : 'Acknowledge' }}
            </button>
          }
        </div>
      }
    </div>
  }

  @if (totalAcknowledgedRequests() > 0) {
    <!-- QA round 2, item I.1 — acknowledged-but-not-done requests, own group. -->
    <div class="nv-notif-panel__group">
      <div class="nv-notif-panel__group-head">
        <span class="nv-notif-panel__label">Acknowledged</span>
      </div>
      @for (request of acknowledgedRequests(); track request.id) {
        <div class="nv-notif-panel__row">
          <div class="nv-notif-panel__row-text">
            <span class="nv-notif-panel__row-title">{{ tableLabel(request.tableId) }} · {{ reasonLabel[request.reason] }}</span>
            @if (request.note) {
              <span class="nv-notif-panel__row-sub">“{{ request.note }}”</span>
            }
            <span class="nv-notif-panel__row-age">{{ ageLabel(request.createdAt) }}</span>
          </div>
          <button
            type="button"
            nvButton="secondary"
            size="xs"
            [disabled]="isAcknowledging(request.id)"
            (click)="markDone(request.id)"
          >
            {{ isAcknowledging(request.id) ? 'Marking done…' : 'Mark done' }}
          </button>
        </div>
      }
    </div>
  }

  @if (totalOpsAlerts() > 0) {
    <div class="nv-notif-panel__group">
      <div class="nv-notif-panel__group-head">
        <span class="nv-notif-panel__label">Alerts</span>
      </div>
      @for (alert of opsAlerts(); track alert.id) {
        <div class="nv-notif-panel__row">
          <div class="nv-notif-panel__row-text">
            <span class="nv-notif-panel__row-title">{{ alert.title }}</span>
            <span class="nv-notif-panel__row-sub">{{ alert.body }}</span>
            <span class="nv-notif-panel__row-age">{{ ageLabel(alert.createdAt) }}</span>
          </div>
          <button
            type="button"
            nvButton="primary"
            size="xs"
            [disabled]="isAcknowledging(alert.id)"
            (click)="acknowledge(alert.id)"
          >
            {{ isAcknowledging(alert.id) ? 'Saving…' : 'Got it' }}
          </button>
        </div>
      }
    </div>
  }

  @if (totalDayCloseAlerts() > 0) {
    <div class="nv-notif-panel__group">
      <div class="nv-notif-panel__group-head">
        <span class="nv-notif-panel__label">Day close</span>
        <button type="button" nvButton="text" size="xs" (click)="viewReceivables()">
          Receivables
        </button>
      </div>
      @for (alert of dayCloseAlerts(); track alert.id) {
        <div class="nv-notif-panel__row">
          <div class="nv-notif-panel__row-text">
            @if (alert.closedCount > 0) {
              <span class="nv-notif-panel__row-title">
                {{ tableList(alert.closedTables) }} auto-closed · ₹{{ formatPrice(alert.dueMinor) }} moved to dues
              </span>
            }
            @if (alert.leftOpenCount > 0) {
              <span class="nv-notif-panel__row-title">{{ tableList(alert.leftOpenTables) }} left open — needs you</span>
              @for (t of alert.leftOpenTables; track t.tableId) {
                <span class="nv-notif-panel__row-sub">{{ t.reason }}</span>
              }
            }
            <span class="nv-notif-panel__row-age">{{ ageLabel(alert.createdAt) }}</span>
          </div>
          <button
            type="button"
            nvButton="primary"
            size="xs"
            [disabled]="isAcknowledging(alert.id)"
            (click)="acknowledge(alert.id)"
          >
            {{ isAcknowledging(alert.id) ? 'Saving…' : 'Got it' }}
          </button>
        </div>
      }
    </div>
  }

  @if (totalPaymentClaims() > 0) {
    <div class="nv-notif-panel__group">
      <div class="nv-notif-panel__group-head">
        <span class="nv-notif-panel__label">Guest paid by UPI — verify</span>
        <button type="button" nvButton="text" size="xs" (click)="viewBilling()">
          Billing
        </button>
      </div>
      @for (claim of paymentClaims(); track claim.id) {
        <div class="nv-notif-panel__row nv-notif-panel__row--claim">
          @if (claim.screenshotUrl) {
            <button
              type="button"
              class="nv-notif-panel__shot"
              aria-label="Open payment screenshot"
              (click)="openScreenshot(claim.screenshotUrl)"
            >
              <img [src]="claim.screenshotUrl" alt="Payment screenshot" />
            </button>
          }
          <div class="nv-notif-panel__row-text">
            <span class="nv-notif-panel__row-title">
              {{ tableLabel(claim.tableId) }} · {{ claim.billRef }} · ₹{{ formatPrice(claim.amountMinor) }}
            </span>
            <span class="nv-notif-panel__row-sub">Unverified — check your UPI app, then settle the bill.</span>
            <span class="nv-notif-panel__row-age">{{ ageLabel(claim.createdAt) }}</span>
          </div>
          <button
            type="button"
            nvButton="primary"
            size="xs"
            [disabled]="isAcknowledging(claim.id)"
            (click)="acknowledge(claim.id)"
          >
            {{ isAcknowledging(claim.id) ? 'Saving…' : 'Got it' }}
          </button>
        </div>
      }
    </div>
  }

  @if (totalOrders() > 0) {
    <div class="nv-notif-panel__group">
      <div class="nv-notif-panel__group-head">
        <span class="nv-notif-panel__label">Orders awaiting approval</span>
        <button type="button" nvButton="text" size="xs" (click)="viewAllOrders()">
          View all ({{ totalOrders() }})
        </button>
      </div>
      @for (order of orders(); track order.id) {
        <button type="button" class="nv-notif-panel__row nv-notif-panel__row--clickable" (click)="viewAllOrders()">
          <div class="nv-notif-panel__row-text">
            <span class="nv-notif-panel__row-title">{{ tableLabel(order.tableId) }}</span>
            <span class="nv-notif-panel__row-sub">₹{{ formatPrice(order.totalMinor) }}</span>
          </div>
        </button>
      }
    </div>
  }
}
